export const EMAIL = "411techsavvy+wecareada@gmail.com";
export const PHONE_DISPLAY = "807.553.0477";
export const PHONE_TEL = "tel:+18075530477";
export const MAILTO = `mailto:${EMAIL}`;
export const SCAN_URL = "https://www.teamalphacoop.com/ada?am_id=edwin9537";

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
